"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=GA4SearchResultPageEvent.js.map